import { render, staticRenderFns } from "./c-slider.vue?vue&type=template&id=6377ed90&scoped=true"
import script from "./c-slider.vue?vue&type=script&lang=js"
export * from "./c-slider.vue?vue&type=script&lang=js"
import style0 from "./c-slider.vue?vue&type=style&index=0&id=6377ed90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6377ed90",
  null
  
)

export default component.exports